import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Autonomerly</h3>
            <p style={{color: '#d1d5db', marginBottom: '16px'}}>
              We build your Autonomous Workforce™ for plumbers, electricians, and HVAC pros. 
              24/7 autonomous AI agents that run your business automatically.
            </p>
          </div>
          
          <div className="footer-section">
            <h3>Services</h3>
            <ul className="footer-links">
              <li>AI Receptionist</li>
              <li>AI Booking Agent</li>
              <li>AI Follow Up</li>
              <li>AI Review Collector</li>
              <li>AI Cold Outreach</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Industries</h3>
            <ul className="footer-links">
              <li>Plumbers</li>
              <li>Electricians</li>
              <li>HVAC Contractors</li>
              <li>All Trade Professionals</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Resources</h3>
            <ul className="footer-links">
              <li>Terms & Conditions</li>
              <li>Privacy Policy</li>
              <li>Support</li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© 2025 Autonomerly. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
